import axios from 'axios';
import Vue from 'vue';

const greenmotion = window.greenmotion || {};
let coreEndpoint = greenmotion.coreEndpoint || '';

const http = axios.create({
    baseURL: API_BASE_URL || coreEndpoint,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});

function getCurrentLocale() {
    if (window.greenmotion?.locale) {
        return window.greenmotion.locale;
    }

    const match = document.cookie.match(new RegExp('(^|;\\s*)locale=([^;]+)'));

    return match ? decodeURIComponent(match[2]) : 'en';
}
const urlParams = new URLSearchParams(window.location.search);
const bookingToken = urlParams.get('t');

// Number of in-flight requests that can change the quote's prices, so the UI can wait for them to settle
export const quotePriceRequests = Vue.observable({ pending: 0 });

// Lookups and detail updates under quotes/ that don't affect the totals
const nonPriceQuoteRequest = /^\/?quotes\/[^/]+\/(vehicles|extras|customers|locale)(\/|\?|$)/;

function affectsQuotePrices(config) {
    const url = config.url || '';

    return /^\/?quotes\//.test(url) && !nonPriceQuoteRequest.test(url);
}

function finishQuotePriceRequest(config) {
    if (config?.tracksQuotePrices) {
        config.tracksQuotePrices = false;
        quotePriceRequests.pending = Math.max(0, quotePriceRequests.pending - 1);
    }
}

// Axios runs request interceptors in reverse registration order, so registering this first means it only
// counts requests once the header/locale preparation below has succeeded
http.interceptors.request.use((config) => {
    if (affectsQuotePrices(config)) {
        config.tracksQuotePrices = true;
        quotePriceRequests.pending += 1;
    }

    return config;
});

http.interceptors.request.use(
    (config) => {
        return new Promise((resolve, reject) => {
            let config;

            try {
                config = Object.assign({ currency: null, guestToken: null, userToken: null }, JSON.parse(localStorage.getItem('HTTP')));
            } catch (exception) {
                config = Object.assign({
                    currency: null,
                    guestToken: null,
                    userToken: null,
                });
            }

            resolve([config.currency, config.guestToken, config.userToken]);
        }).then((results) => {
            if (results[0]) {
                config.headers['Accept-Currency'] = results[0];
            }

            const hasAuthenticatedFlag = 'authenticated' in greenmotion;
            const authenticated = greenmotion.authenticated || false;

            if ((hasAuthenticatedFlag && authenticated && results[2]) || (!hasAuthenticatedFlag && results[2])) {
                config.headers['Authorization'] = `Bearer ${results[2]}`;
            } else if (results[1]) {
                config.headers['Guest-Authorization'] = `Token ${results[1]}`;
            }

            const locale = getCurrentLocale();

            if (locale) {
                // TODO: Remove the "com-" replace once the locales system is complete
                config.headers['Accept-Language'] = locale.replace('com-', '');
            }

            config.params = config.params || {};

            if (bookingToken) {
                config.params.booking_token = bookingToken;
            }

            return config;
        });
    },
    (error) => {
        // TODO: What kind of error needs handling here?
        return Promise.reject(error);
    }
);

http.interceptors.response.use(
    (response) => {
        finishQuotePriceRequest(response.config);
        return response;
    },
    (error) => {
        finishQuotePriceRequest(error?.config);
        return Promise.reject(error);
    }
);

export const HTTP_CONFIG = (currency, guestToken, userToken) => {
    localStorage.setItem(
        'HTTP',
        JSON.stringify({
            currency,
            guestToken,
            userToken,
            isLandingPage: false,
        })
    );
};

export const HTTP = http;

var bookingHTTP = axios.create({
    baseURL: `${location.protocol}//${location.host}`,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
});

export const BOOKINGHTTP = bookingHTTP;
